import {request} from '../request';
import {SinglePageApplication} from '../../types/project/Application';

export async function deleteSinglePageApplication(applicationId: string, spaId: string) {
  return request<SinglePageApplication>({
    method: 'get',
    url: `/application/spa/delete?&applicationId=${applicationId}&spaId=${spaId}`,
  });
}
